import { AuthCall } from '../../infra/call/auth/AuthCall';
import { RequestApi } from '../../domain/contract/HttpContract';

/**
 * AddressUseCase
 * responsável pelas requisições busca de endereço
 */
export class AddressUseCase {
  constructor(private readonly endPoint: string) {
    this.endPoint = endPoint;
  }

  /**
   * Post
   * @param request
   * @constructor
   */
  async Get(request?: RequestApi) {
    return await AuthCall({
      url: this.endPoint,
      method: 'GET',
      body: request?.data,
      headers: request?.headers,
    }).then((response) => response);
  }
}
